import Animating from './animator_states/Animating';
import Idle from './animator_states/Idle';

export default class Animator
{
  constructor(from, to, duration, easing_function, set_property_value_function)
  {
    this.from = from;
    this.to = to;
    this.duration = duration;
    this.easing_function = easing_function;
    this.set_property_value = set_property_value_function;

    this.current_state = new Idle();
  }

  animate()
  {
    this.set_current_state(new Animating());
  }

  // stop_animation()
  // {
  //   this.set_current_state(new Idle());
  // }

  update()
  {
    this.current_state.update(this);
  }

  is_animating()
  {
    return this.current_state.is_animating();
  }

  set_current_state(state)
  {
    this.current_state.on_exit(this);
    this.current_state = state;
    this.current_state.on_enter(this);
  }
}
